import styled from "styled-components";

export const FlexLeft = styled.div`
display:flex;
align-items:center;
flex-wrap: wrap;
justify-content: flex-start;
gap:25px;
box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
0 2px 4px -1px rgba(0, 0, 0, 0.06);
background-color: #ffe9f4;
    border-radius: 10px;
    max-width: 900px;
    margin: 0 auto;
`